import comp from "./SelectableCard";
export default comp;
